if (!customElements.get('card-product-take-all-buttons')) {
  customElements.define(
    'card-product-take-all-buttons',
    class CardProductTakeAllButtons extends HTMLElement {
      constructor() {
        super();
        this.bindEvents();
        this.initializeButtonStates();
      }

      bindEvents() {
        this.addEventListener('click', this.handleClick.bind(this));
        
        document.addEventListener('input', (event) => {
          if (event.target.matches('input[data-quantity-variant-id]')) {
            this.updateButtonStates(event.target);
          }
        });

        document.addEventListener('change', (event) => {
          if (event.target.matches('input[data-quantity-variant-id]')) {
            this.updateButtonStates(event.target);
          }
        });
      }

      handleClick(event) {
        if (event.target.closest('.card-take-all-btn')) {
          this.handleTakeAll(event);
        } else if (event.target.closest('.card-remove-all-btn')) {
          this.handleRemoveAll(event);
        }
      }

      initializeButtonStates() {
        const quantityInputs = this.getQuantityInputs();
        quantityInputs.forEach(input => {
          this.updateButtonStates(input);
        });
      }

      handleTakeAll(event) {
        event.preventDefault();
        
        const button = event.target.closest('.card-take-all-btn');
        if (button.disabled) return;
        
        const variantId = button.dataset.variantId;
        const maxQuantity = parseInt(button.dataset.maxQuantity, 10);
        const quantityInput = this.getQuantityInput(variantId);
        
        if (quantityInput && maxQuantity > 0) {
          this.setQuantityAndTrigger(quantityInput, maxQuantity);
        }
      }

      handleRemoveAll(event) {
        event.preventDefault();
        
        const button = event.target.closest('.card-remove-all-btn');
        if (button.disabled) return;
        
        const variantId = button.dataset.variantId;
        const quantityInput = this.getQuantityInput(variantId);
        
        if (quantityInput) {
          this.setQuantityAndTrigger(quantityInput, 0);
        }
      }

      updateButtonStates(quantityInput) {
        const variantId = quantityInput.dataset.quantityVariantId;
        const currentValue = parseInt(quantityInput.value, 10) || 0;
        const maxQuantity = parseInt(quantityInput.getAttribute('max'), 10) || 0;
        
        const takeAllButton = this.getTakeAllButton(variantId);
        const removeAllButton = this.getRemoveAllButton(variantId);
        
        if (takeAllButton) {
          takeAllButton.disabled = (currentValue >= maxQuantity) || (maxQuantity === 0);
        }
        
        if (removeAllButton) {
          removeAllButton.disabled = (currentValue === 0);
        }
      }

      setQuantityAndTrigger(input, value) {
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      getQuantityInputs() {
        return document.querySelectorAll('input[data-quantity-variant-id]');
      }

      getQuantityInput(variantId) {
        return document.querySelector(`input[data-quantity-variant-id="${variantId}"]`);
      }

      getTakeAllButton(variantId) {
        return document.querySelector(`.card-take-all-btn[data-variant-id="${variantId}"]`);
      }

      getRemoveAllButton(variantId) {
        return document.querySelector(`.card-remove-all-btn[data-variant-id="${variantId}"]`);
      }
    }
  );
}